import { Auth0Provider } from '@auth0/auth0-react';
import { Config } from 'core/commonTypes';
import propTypes from 'prop-types';
import { PropsWithChildren } from 'react';
import { getUA } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { MockAuth0Provider } from './mock';

export type LocalAuth0Props = PropsWithChildren<{
  config: Config;
}>;
const Auth0ProviderWithHistory = ({ config, children }: LocalAuth0Props) => {
  const navigate = useNavigate();
  const isRDT = getUA.endsWith('CwH MSAL bridge Co-worker Hub');

  if (config.ssoClientId === 'mock') {
    return <MockAuth0Provider {...config}>{children}</MockAuth0Provider>;
  }

  const onRedirectCallback = appState => {
    // console.log(`Pushing back: ${appState}`) // FIXME: Use abstracted logging
    navigate(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={config.ssoDomain}
      clientId={config.ssoClientId}
      redirectUri={`${window.location.origin}${config.redirectUri}`}
      onRedirectCallback={onRedirectCallback}
      audience={config.audience}
      scope={config.scope}
      cacheLocation={isRDT ? 'localstorage' : 'memory'}
      // prompt reauth after 8h for RDT
      maxAge={isRDT ? 60 * 60 * 8 : undefined}
    >
      {children}
    </Auth0Provider>
  );
};

Auth0ProviderWithHistory.propTypes = {
  children: propTypes.node,
  config: propTypes.shape({
    ssoDomain: propTypes.string,
    ssoClientId: propTypes.string,
    redirectUri: propTypes.string,
    audience: propTypes.string,
    scope: propTypes.string,
  }),
};

export default Auth0ProviderWithHistory;
